const PackCard = () => {
  return (
    <div className=" border-b border-[#e4e4e7]  transition-all rounded-lg hover:shadow-lg border">
      <div className="relative bg-white rounded-lg flex flex-col xsm:p-4 p-3">
        <div className="relative overflow-hidden grow-0 shrink-0 ml-0 rounded-lg mb-4 w-auto basis-[unset] xsm:h-[140px] h-28 bg-gray-50 animate-pulse" />
        <div className="h-[84px]">
          <div className="w-40 h-5 bg-gray-50 animate-pulse rounded mb-2" />
          <div className="flex gap-x-2">
            <div className="w-40 h-5 bg-gray-50 animate-pulse rounded" />
            <div className="w-40 h-5 bg-gray-50 animate-pulse rounded" />
          </div>
        </div>
      </div>
      <div className="pl-2 pr-4 h-16 rounded-b-lg bg-[#FAFAFA] border-t border-t-[#F4F4F5] justify-center flex items-center">
        <div className="w-20 h-5 bg0gray-50 animate-pulse" />
      </div>
    </div>
  );
};
export default PackCard;
